import { createRoot } from "react-dom/client";
import "typeface-roboto";
import { PublicClientApplication } from "@azure/msal-browser";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { loadConfig, Config } from "./config";
import { BrowserRouter as Router } from "react-router-dom";

const runApp = async () => {
    let cfg: Config = await loadConfig();
    const container = document.getElementById("root");
    const root = createRoot(container!); // createRoot(container!) if you use TypeScript
    if (cfg.auth.clientId !== "") {
        const msalInstance = new PublicClientApplication(cfg);
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
            msalInstance.setActiveAccount(accounts[0]);
        }
        await msalInstance.initialize();
        root.render(
            <Router basename={process.env.PUBLIC_URL}>
                <App pca={msalInstance} />
            </Router>);
    } else {
        const pca = {
            _user: {
                profile: {
                    name: "Guest",
                    given_name: "",
                    family_name: "",
                },
            },
            config: {
                auth: {
                    clientId: "",
                },
            },
            getCachedToken: () => "",
            connectionState: 0,
        };
        root.render(
            <Router basename={process.env.PUBLIC_URL}>
                <App pca={pca} />
            </Router>
        );
    }
};

runApp();

serviceWorker.unregister();
